import { Directive, ElementRef, OnInit, Optional, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { SecurityService } from '../../core/services/security.service';

@Directive({
	selector: '[checkFullReadonly]'
})
export class CheckFullReadonlyDirective implements OnInit {
	private readonly fullReadonlyRightKey = 'FullReadonly';

	constructor(
		@Optional() private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private elementRef: ElementRef,
		private renderer: Renderer2,
		private securityService: SecurityService) { }

	ngOnInit(): void {
		if (this.securityService.isSpecialRightClaimValid(this.fullReadonlyRightKey)) {
			this.hideElement();
			return;
		}

		if (this.templateRef) {
			this.viewContainer.createEmbeddedView(this.templateRef);
		}
	}

	private hideElement(): void {
		if (this.templateRef) {
			this.viewContainer.clear();
			return;
		}

		const element = this.elementRef.nativeElement;
		const parent = element.parentNode;

		if (parent) {
			this.renderer.removeChild(parent, element);
		}
	}
}
